export const SIDE_PANEL_FILE_NAME = 'side-panel.html';
export const CHROME_EXT_STORAGE_KEY = 'chromeExtensionState';
